import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  SHOW_POPUP_BUY_REPORT,
  SHOW_POPUP_FACTSHEET,
} from '../../../helpers/EventEmitter'
import { Element } from '../../html/element'
import { PopupAction } from '../PopupAction'
import './i18n'

export const PopupBuyReport = () => {
  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    const showPopup = () => {
      setIsShow(true)
    }
    EventEmitter.subscribe(SHOW_POPUP_BUY_REPORT, showPopup)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_BUY_REPORT, showPopup)
    }
  }, [])

  const handleClose = () => {
    setIsShow(false)
  }

  const handleSubmit = () => {
    setIsShow(false)
    EventEmitter.dispatch(SHOW_POPUP_FACTSHEET, true)
  }

  return (
    <PopupAction
      isShow={isShow}
      title={'common.popup.popupBuyReport.TITLE'}
      btnSubmit={{
        label: 'common.popup.popupBuyReport.DOWNLOAD_FF',
        isI18n: true,
        event: handleSubmit,
      }}
      btnCancel={{
        label: 'common.popup.popupBuyReport.NOT_NOW',
        isI18n: true,
        event: handleClose,
      }}
      footerStyle={{ justifyContent: 'center' }}
      handleClose={handleClose}
    >
      <Element style={{ color: '#3A414B' }}>
        <Translate value={'common.popup.popupBuyReport.DESC'} />
      </Element>
    </PopupAction>
  )
}
